<template>
  <div class="">
    <v-dialog v-model="bulkdialog" width="500">
      <v-card>
        <v-card-title>
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              import-attendee-head
            "
          >
            <h5 v-if="type == 'attendee' || type == 'invitee'">Import Attendee</h5>
            <h5 v-else-if="type == 'speaker'">Import Speaker</h5>

            <v-icon color="#1c1d26" size="25px" @click="bulkdialog = false"
              >mdi-close</v-icon
            >
          </div>
        </v-card-title>

        <v-card-text>
          <div class="attendee-bulk-upload-wrap mt-3">
            <h5 class="d-flex justify-content-between align-items-center">

              Download the template
              <v-btn
                v-if="type == 'invitee'"
                color="#2376e5"
                outlined
                class="save-standard"
                href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_Invitee.xlsx?alt=media&token=e36481d3-70ea-4d53-916a-e2d822a59140"
                ><v-icon color="#2376e5" size="18px" class="mr-2"
                  >mdi-tray-arrow-down</v-icon
                >
                Download</v-btn
              >
              <v-btn
                v-else
                color="#2376e5"
                outlined
                class="save-standard"
                href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_Attendee.xlsx?alt=media&token=af0ac634-c0d2-4034-baec-1e552285635f"
                ><v-icon color="#2376e5" size="18px" class="mr-2"
                  >mdi-tray-arrow-down</v-icon
                >
                Download</v-btn
              >
            </h5>
            <div class="xlsx-upload-wrap mt-8">
              <p>Select XLSX file</p>
              <div class="d-flex justify-content-center align-items-center">
                <input
                  type="file"
                  id="multi_file"
                  accept=".csv, .xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                <v-btn
                  class="save-standard"
                  color="#2376e5"
                  outlined
                  @click="UploadBulkUploadFile()"
                  ><v-icon color="#2376e5" size="18px" class="mr-2"
                    >mdi-tray-arrow-up</v-icon
                  >
                  Upload</v-btn
                >
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import bu from "@/mixins/BulkUpload.js";
var self;
export default {
  props: {
    type: String,
  },
  data() {
    return {
      bulkdialog: false,
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {
    self = this;
    self.bulkdialog = true;
  },
  mounted() {},
  methods: {
    
    UploadBulkUploadFile() {
      var files = document.getElementById("multi_file").files;
      bu.initVueComps(self);
      bu.StartUploadPrecss(files, self.type);
    },
  },
};
</script>
<style>
/* .no-reg-events {
  margin: 0 auto;
  text-align: center;
}
.no-reg-events h3 {
  font-weight: 700;
  font-size: 30px;
  color: #333;
  margin-bottom: 25px;
}
.no-reg-events a {
  display: inline-block;
  padding: 8px 30px;
  background: #00a982;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 5px;
  box-shadow: 0 5px 0 rgba(0, 0, 0, 0.5);
  margin-top: 15px;
}
.no-reg-events a:active {
  transform: translateY(5px);
  box-shadow: none;
}
.event-list-register-shimmer photo {
  display: block;
  width: 100%;
  height: 88px;
}
.shine {
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 100%;
  display: inline-block;
  position: relative;

  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: placeholderShimmer;
  -webkit-animation-timing-function: linear;
}
.top-right-login.hdr-btn {
  padding: 0 0 15px;
}
.top-right-login.hdr-btn a.login,
.top-right-login.hdr-btn a.event-List {
  font-size: 18px;
  padding-right: 0 !important;
  margin-left: 25px;
  cursor: pointer;
  background-position: left center;
}
.left-logo.edu-banner {
  width: 100% !important;
}
.event-box-list-wrapper .ev-box {
  border-radius: 5px;
  cursor: pointer;
}
section.event-box-list-wrapper {
  margin-top: 25px;
}
@media only screen and (max-width: 767px) {
   .left-logo.edu-banner {
  display: none;
} 
  .left-logo.edu-banner a {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .left-logo.edu-banner a img {
    width: 100%;
    height: 100%;
  }
  .reg-event-banner {
    padding: 20px 0 !important;
    margin-top: 24px;
  }
  .edu-rage .reg-event-banner h1 {
    margin-top: 0;
  }
} */
</style>
